<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <div class="dropdown d-inline">
    <Button id="orderOutboxStatusFilter" color="primary" :title="$t('key_filter_status')" class="dropdown-toggle " :variant="statusSelected == '' ? 'outline' : 'fill'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-tags me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="orderOutboxStatusFilter">
      <li>
        <button class="dropdown-item border-radius-md text-statuspending" :class="[filterStatusSelected=='PENDING'?'active-item':'']" type="button" @click="handleClick('PENDING')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-hourglass-start me-3 text-statuspending"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_pending') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-statussended" :class="[filterStatusSelected=='SENDED'?'active-item':'']" type="button" @click="handleClick('SENDED')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-paper-plane me-3 text-statussended"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_sended') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-statusconfigerror" :class="[filterStatusSelected=='CONFIG_ERROR'?'active-item':'']" type="button" @click="handleClick('CONFIG_ERROR')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-triangle-exclamation me-3 text-statusconfigerror"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_config_error') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-statusinvalid" :class="[filterStatusSelected=='INVALID'?'active-item':'']" type="button" @click="handleClick('INVALID')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-bug me-3 text-statusinvalid"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_invalid') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-statuserror" :class="[filterStatusSelected=='ERROR'?'active-item':'']" type="button" @click="handleClick('ERROR')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-xmark me-3 text-statuserror"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_error') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-statusdead" :class="[filterStatusSelected=='DEAD'?'active-item':'']" type="button" @click="handleClick('DEAD')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-skull-crossbones me-3 text-statusdead"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_dead') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import Button from "./../../../../../generic_components/Button.vue";

  export default {
    name:"OrderOutboxQueueStatusFilter",
    components: {
      Button
    },
    props: {
      filterStatusSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['order-outbox-queue-status-filter-change'],
    data() {
      return {
        statusSelected: ''
      }
    },
    watch: {
      filterStatusSelected() {
        this.statusSelected = this.filterStatusSelected;
      }
    },
    methods: {
      handleClick(status) {
        this.statusSelected = status;
        this.$emit('order-outbox-queue-status-filter-change', status);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }
  }

</script>
